import { render, staticRenderFns } from "./empresaCR.vue?vue&type=template&id=c5377652&"
import script from "./empresaCR.vue?vue&type=script&lang=js&"
export * from "./empresaCR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports